export default function(document) {
  const converters = {
    A: (e) => ({
      href: e.getAttribute('href'),
      target: e.getAttribute('target'),
    }),
  }

  const toTextModel = (content) => {
    let elem
    const tags = []
    const temp = document.createElement('div')
    document.body.appendChild(temp)
    temp.innerHTML = content
    let offset = 0
    while ((elem = temp.firstElementChild)) {
      const type = elem.nodeName
      const startIndex =
        offset +
        (elem.previousSibling ? elem.previousSibling.nodeValue.length : 0)
      const length = elem.textContent.length
      offset = startIndex + length
      const range = makeRange(elem, startIndex, length)
      const elemFrag = range.extractContents()
      const props = converters[type] ? converters[type](elem) : {}
      // call method here to get the attributes needed (aka href, src, etc)
      tags.push({ type, startIndex, length, props })
      temp.replaceChild(elemFrag, elem)
    }
    temp.normalize()
    const html = temp.innerHTML
    temp.remove()
    return { content: html, tags }
  }

  const getTextNodes = (node) => {
    const textNodes = []
    if (node.nodeType === 3) {
      textNodes.push(node)
    } else {
      const children = Array.from(node.childNodes)
      children.forEach((child) => {
        textNodes.push.apply(textNodes, getTextNodes(child))
      })
    }
    return textNodes
  }

  const makeRange = (elem, start, length) => {
    const range = document.createRange()
    const end = start + length

    range.selectNodeContents(elem)
    const textNodes = getTextNodes(elem)

    let hasStart = false
    let currCount = 0
    let endCount = 0
    for (let i = 0; i < textNodes.length; i++) {
      let textNode = textNodes[i]
      endCount = currCount + textNode.length
      if (!hasStart && start >= currCount && start <= endCount) {
        hasStart = true
        range.setStart(textNode, start - currCount)
      }
      // no else if because start and end can be in same node
      if (hasStart && end <= endCount) {
        range.setEnd(textNode, end - currCount)
        break
      }
      currCount = endCount
    }
    range._debug = {}
    return range
  }

  // const setSelectionRange = (elem, start, length) => {
  //   const range = makeRange(elem, start, length)
  //   const selection = window.getSelection()
  //   selection.removeAllRanges()
  //   selection.addRange(range)
  //   return range
  // }

  /* TAKES THE CONTENT AND ARRAY AND BUILDS HTML STRING */
  const toElems = (content, attrs) => {
    const temp = document.createElement('div')
    temp.innerHTML = content
    document.body.appendChild(temp)
    attrs
      .sort((a, b) => (b.startIndex - a.startIndex ? 1 : -1))
      .reverse()
      .forEach((o) => {
        const range = makeRange(temp, o.startIndex, o.length)
        const elem = document.createElement(o.type)

        // forward props - is this necessary?
        Object.keys(o.props).forEach((k) => {
          if (o.props[k]) {
            elem[k] = o.props[k]
          }
        })

        // add html string attrs
        Object.entries(o.attrs || {}).forEach(([key, val]) => {
          elem.setAttribute(key, val)
        })

        const elemFrag = range.cloneContents()
        elem.appendChild(elemFrag)
        range.deleteContents()
        range.insertNode(elem)
      })
    temp.normalize()
    const html = temp.innerHTML
    temp.remove()
    return html
  }

  /* FIND ALL OCCURANCES OF THE STRING */
  const findWord = (wrd, content, tags, caseSensitive, count = 0) => {
    const re = caseSensitive ? new RegExp(wrd, 'g') : new RegExp(wrd, 'gi')
    let result
    while ((result = re.exec(content))) {
      tags.push({
        length: wrd.length,
        props: {},
        attrs: {
          'data-findex': count++,
          class: 'el-find-result',
        },
        startIndex: result.index,
        type: 'MARK',
      })
    }
    return { content, tags, count }
  }

  /* FINDS AND REPLACES ALL OCCURANCES OF THE STRING */
  const replaceWord = (wrd, replacement, content, tags, caseSensitive) => {
    const re = caseSensitive ? new RegExp(wrd, 'g') : new RegExp(wrd, 'gi')
    let result
    const indexes = []
    while ((result = re.exec(content))) {
      indexes.push(result.index)
    }
    indexes.reverse().forEach((ind) => {
      content = content.replace(re, replacement)
      var diff = replacement.length - wrd.length
      if (diff !== 0) {
        tags.forEach((o) => {
          // MISSING range starts before, but includes entire word

          if (o.startIndex + wrd.length > ind + wrd.length) {
            o.startIndex += diff
            if (o.startIndex < ind) {
              o.startIndex = -1
            }
          } else if (o.startIndex >= ind) {
            o.length += diff
          }
        })
        tags = tags.filter((o) => o.startIndex > 0 && o.length > 0)
      }
    })
    return { content, tags }
  }

  /* REMOVE THE FIND RESULTS FROM THE ELEM */
  const removeMarks = (elems) => {
    ;[].concat(elems).forEach((el) => {
      const marks = el.querySelectorAll('mark')
      if (marks.length) {
        marks.forEach((mark) => {
          const parNode = mark.parentNode
          while (mark.firstChild) {
            parNode.insertBefore(mark.firstChild, mark)
          }
          parNode.removeChild(mark)
        })
      }
    })
  }

  return {
    converters,
    toTextModel,
    getTextNodes,
    makeRange,
    toElems,
    findWord,
    replaceWord,
    removeMarks,
  }
}
